export default ({ params, route, redirect, app, next }) => {
    if (app.$auth.user.id !== parseInt(params.userId)){
        return redirect('/users/' + params.userId + '/');
    }
}